import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => {
	return {
		root: {},
		imgBox: {
			'& img': {
				width: '100%',
				height: '100%',
				objectFit: 'contain',
			},
		},
	};
});
